export default __webpack_public_path__ + "static/certificate-3bfd02dbadeba7a81eff3cca1e9ad636.webp";